export default __webpack_public_path__ + "static/media/guide_img_3.9e8f8a44.png";